<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
    <div class="form-group" [formGroup]="form">
    <app-action-alert controlName="volume" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
    <app-unit-quantity label="Volume" unitLabel="ml" placeholder="Value" inputMode="decimal" formControlName="volume"></app-unit-quantity>
    <app-action-alert controlName="rate" [alerts]="item!.actionAlerts" [form]="form"></app-action-alert>
    <app-unit-quantity label="Rate" unitLabel="ml/kg/hr" placeholder="Value" inputMode="decimal" formControlName="rate"></app-unit-quantity>
  </div>
    <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
  </div>
</app-action-form>
